function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1 12.25l12.5-7.5m-8.054-2.5L7.25 4.125 9.054 2.25H5.446zm3.608 12.5L7.25 12.875 5.446 14.75h3.608zM7.25 1v15V1zM1.14 6.999l2.464-.686-.66-2.562L1.14 7zM13.36 10l-2.464.687.66 2.56 1.805-3.247zM1 4.75l12.5 7.5L1 4.75zm1.944 8.499l.66-2.562-2.464-.686 1.804 3.248zm8.612-9.498l-.66 2.562 2.464.686-1.804-3.248z",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgFrozenGoodsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    fill: "none"
  }, props), _ref);
}

export default SvgFrozenGoodsIcon;